var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid96(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4167 17.5H22.5V4.58334L32.9167 4.58334C34.2974 4.58334 35.4167 5.70263 35.4167 7.08334V17.5ZM23.3333 16.6667H34.5833V7.08334C34.5833 6.16287 33.8371 5.41668 32.9167 5.41668L23.3333 5.41668V16.6667Z",
    fill: "#009FDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4997 17.5H4.58301L4.58301 7.08334C4.58301 5.70263 5.7023 4.58334 7.08301 4.58334L17.4997 4.58334V17.5ZM5.41634 16.6667H16.6663V5.41668L7.08301 5.41668C6.16253 5.41668 5.41634 6.16287 5.41634 7.08334L5.41634 16.6667ZM17.4997 35.4167H7.08301C5.7023 35.4167 4.58301 34.2974 4.58301 32.9167L4.58301 22.5H17.4997L17.4997 35.4167ZM5.41634 23.3333L5.41634 32.9167C5.41634 33.8372 6.16253 34.5833 7.08301 34.5833H16.6663L16.6663 23.3333H5.41634ZM32.9163 35.4167H22.4997V22.5H35.4163V32.9167C35.4163 34.2974 34.2971 35.4167 32.9163 35.4167ZM23.333 34.5833H32.9163C33.8368 34.5833 34.583 33.8372 34.583 32.9167V23.3333H23.333V34.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid96);
export default __webpack_public_path__ + "static/media/grid_96.51dc216d9b980d92cd8324d0af26417f.svg";
export { ForwardRef as ReactComponent };